export const FORM_FIELDS_NAMES = {
    DEPARTMENT_ID: "departmentId",
    DEPARTMENT_ADMIN:"departmentAdmin",
    DEPARTMENT_NAME:"departmentName",
    DEPARTMENT_CONTACT_NUMBER:"contactNumber",
    DEPARTMENT_STATTUS: 'status'
}